import { PasswordWithStrength } from 'ipro-ui-kit-vuejs/src/components';

import { AuthService } from '@/auth';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  components: {
    PasswordWithStrength,
  },
  mixins: [
    AuthRoutes,
  ],
  data() {
    return {
      inputs: {
        password: {
          properties: {
            label: 'Password',
            name: 'password',
            required: true,
          },
          value: '',
        },
      },
      requestInProgress: false,
    };
  },
  computed: {
    uuid() {
      return this.$route.query.user_uuid;
    },
    reset_token() {
      return this.$route.query.reset_token;
    },
  },
  created() {
    if (!this.uuid || !this.reset_token) {
      this.$router.replace(this.routes.passwordReset);
    }
  },
  methods: {
    async passwordResetConfirm() {
      this.requestInProgress = true;

      try {
        const params = {
          password: this.inputs.password.value,
          uuid: this.uuid,
          reset_token: this.reset_token,
        };
        await AuthService.passwordResetConfirm(params);

        this.$router.push(this.routes.login);
      } catch (error) {
        // Do nothing
      }

      this.requestInProgress = false;
    },
  },
};
